"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRedux = require("react-redux");

var _react = _interopRequireDefault(require("react"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _colors = require("HubStyleTokens/colors");

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _reactRouterDom = require("react-router-dom");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _StickyContainer = _interopRequireDefault(require("../common/StickyContainer"));

var _TabConfig = require("../../constants/TabConfig");

var _MobileTabs = _interopRequireDefault(require("./MobileTabs"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var getSecondaryTabStyle = function getSecondaryTabStyle(_ref) {
  var id = _ref.id,
      selected = _ref.selected;
  return id === selected ? {
    backgroundColor: _colors.CALYPSO_LIGHT
  } : {};
};

function Tabs(_ref2) {
  var selectedPrimaryTab = _ref2.selectedPrimaryTab,
      selectedSecondaryTab = _ref2.selectedSecondaryTab,
      history = _ref2.history,
      defaultHubRoute = _ref2.defaultHubRoute,
      isHSFXEligible = _ref2.isHSFXEligible,
      isLatamEsEligible = _ref2.isLatamEsEligible;
  var discountBadgeKey = isLatamEsEligible ? 'latamEsPercentDiscountBadge' : 'percentDiscountBadge';
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_MobileTabs.default, {
    selectedPrimaryTab: selectedPrimaryTab,
    selectedSecondaryTab: selectedSecondaryTab,
    isHSFXEligible: isHSFXEligible,
    discountBadgeKey: discountBadgeKey,
    history: history
  }), _react.default.createElement(_UITabs.default, {
    selected: selectedPrimaryTab,
    use: "enclosed",
    wrapperClassName: "pricing-page-tabs md-hidden"
  }, _react.default.createElement(_UITab.default, {
    tabId: "products",
    className: "pricing-page-tab",
    onClick: function onClick() {
      (0, _urls.tabsNavigateTo)({
        path: defaultHubRoute,
        history: history
      });
    },
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.products.tabTitle"
    })
  }), _react.default.createElement(_UITab.default, {
    tabId: "bundle",
    className: "pricing-page-tab",
    onClick: (0, _partial.default)(_urls.tabsNavigateTo, {
      path: '/growth-suite',
      history: history
    }),
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.productCategories.bundles"
    })
  })), _react.default.createElement(_StickyContainer.default, null, _react.default.createElement(_UITabs.default, {
    selected: selectedSecondaryTab,
    wrapperClassName: "products-page-tabs md-hidden",
    bordered: true
  }, _TabConfig.TabConfig[selectedPrimaryTab].map(function (tab) {
    return _react.default.createElement(_UITab.default, {
      key: tab.id,
      tabId: tab.id,
      className: "products-page-tab",
      onClick: (0, _partial.default)(_urls.tabsNavigateTo, {
        path: "/" + (tab.slug || tab.id),
        history: history
      }),
      title: tab.title({
        isHSFXEligible: isHSFXEligible,
        discountBadgeKey: discountBadgeKey
      }),
      style: getSecondaryTabStyle({
        id: tab.id,
        selected: selectedSecondaryTab
      })
    });
  }))));
}

function mapStateToProps(state) {
  return {
    defaultHubRoute: state.config.defaultHubRoute,
    isHSFXEligible: (0, _PromotionSelectors.isHSFXEligibleSelector)(state),
    isLatamEsEligible: (0, _PromotionSelectors.isLatamEsEligibleSelector)(state)
  };
}

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Tabs));

exports.default = _default;
module.exports = exports.default;